import { FormField, Text, TextField } from "designSystem/index";
import React from "react";

export default () => (
	<div
		style={{
			textAlign: "left",
		}}
	>
		<div>
			<FormField
				control={(
					<TextField
						autoFocus
						name="textField"
					/>
				)}
				label={<Text bold res="Text Field" />}
				labelPlacement="start"
				standalone
			/>
		</div>
		<div>
			<FormField
				control={(
					<TextField
						autoFocus
						fullWidth
						name="textField"
					/>
				)}
				fullWidth
				label={<Text bold res="Full Width Field" />}
				labelPlacement="start"
				standalone
			/>
		</div>
	</div>
);

